import uniqid from 'uniqid'
import './Style.css'

const EducationContainer = ({ education }) => (
  <div className='education-card'>
    <h3>{education.degree}</h3>
    <h5>{education.institution}</h5>
    <p className='education__details'>
      {education.duration} | {education.location}
    </p>
    <p className='education__description'>{education.description}</p>
    <ul className='education__highlights experience__responsibilities'>
      {education.highlights.map((item) => (
        <li key={uniqid()}>{item}</li>
      ))}
    </ul>

    <a
      href={education.institutionUrl}
      aria-label='institution website'
      className='link link--icon'
    />
  </div>
)

export default EducationContainer
